// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"5d10711a","977":"5b40af67"}[chunkId] + ".chunk.js";
};